class LightGallery {
  constructor() {
    console.log(">>> LightGallery constructor");

    let lightGalleries = document.querySelectorAll(".js-lightgallery");

    lightGalleries.forEach((lGallery, index) => {
      $(".js-lightgallery").lightGallery({
        selector: ".js-lightgallery-photo",
        mode: "lg-fade",
        speed: 400,
        loop: false,
        thumbnail: false,
        download: true,
        zoom: true,
        fullScreen: false,
        share: false,
        getCaptionFromTitleOrAlt: false,
        subHtmlSelectorRelative: false,
        autoplayControls: false,
        closable: false,
        // hideBarsDelay: 1000,
        // dynamic: true,
        // dynamicEl: [
        //   {
        //     iframe: "true",
        //     src: lGallery.dataset.pdf,
        //   },
        // ],
      });

      lGallery.classList.add(`-lightgallery-${index + 1}`);
      lGallery
        .querySelector(`.js-trigger-lightgallery`)
        .addEventListener("click", (e) => {
          e.preventDefault();
          let lGalleryInit = e.target
            .closest(".js-lightgallery")
            .querySelector(".js-lightgallery-init");
          lGalleryInit.click();
        });
    });
  }
}

export default LightGallery;
